import { useMutation } from '@tanstack/react-query';

import { split } from '../../../../../../api';
import { Position } from '../../../../../../types/position';

export const useSplit = () =>
  useMutation({ mutationKey: ['split'], mutationFn: (data: Partial<Position>) => split(data) });
